import { render, staticRenderFns } from "./index.vue?vue&type=template&id=265b9593&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265b9593",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('265b9593')) {
      api.createRecord('265b9593', component.options)
    } else {
      api.reload('265b9593', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=265b9593&scoped=true", function () {
      api.rerender('265b9593', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/pointsMall/section/index.vue"
export default component.exports